import { useNavigate } from 'react-router-dom';
import { ChatHeader } from './ChatHeader';
import { ChatHistorySidebar } from './ChatHistorySidebar';
import { ChatContent } from './ChatContent';

export const ChatInterface = () => {
  const navigate = useNavigate();

  // The history panel owns its own state, actions and (on mobile) its own
  // scrim — it reads what it needs straight from context, so nothing is
  // threaded through here any more.
  return (
    <div className="relative flex h-dvh">
      <ChatHistorySidebar />
      <div className="flex min-h-0 min-w-0 flex-1 flex-col">
        <ChatHeader />
        <div className="flex min-h-0 flex-1 flex-col overflow-hidden p-4 md:p-8">
          <div className="flex h-full w-full flex-col overflow-hidden">
            <div className="flex min-h-0 flex-1 flex-col overflow-hidden">
              <ChatContent onGoBack={() => navigate('/')} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
